import React, { createContext, useState } from 'react';

import MeetClassificationFlatData from './MeetClassificationFlatData';

export const MeetClassificationFlatStateContext = createContext();

const MeetClassificationFlatContextProvider = ({ children }) => {
  const stateHook = useState(MeetClassificationFlatData.INITIAL_STATE);

  return (
    <MeetClassificationFlatStateContext.Provider value={stateHook}>
      {children}
    </MeetClassificationFlatStateContext.Provider>
  );
};

export default MeetClassificationFlatContextProvider;